import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { SNACKBAR } from '../../../../redux/action/type.action';

const useSnackBarStyles = makeStyles(theme => ({
  success: {
    backgroundColor: '#43a047',
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: '#ffa000',
  },
  important: {
    backgroundColor: theme.palette.primary.main,
    textTransform: "uppercase"
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const SnackBarComponent = () => {
  const classes = useSnackBarStyles();
  const dispatch = useDispatch();
  let reducer = useSelector((state: any) => state[SNACKBAR.name]);
  const [state, setState]: any = useState(reducer);

  useEffect(() => {
    setState(reducer)
  }, [reducer])
  
  const handleSnackBarClose = () => {
    if (state.handleClose) {
      state.handleClose();
    }
    dispatch({
      type: SNACKBAR.clear
    });
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={state?.open}
      autoHideDuration={state?.duration ? state?.duration : 2000}
      onClose={handleSnackBarClose}
    >
      <SnackbarContent
        className={clsx(state?.variant ? classes[state?.variant] : classes.info, state?.className)}
        message={
          <span className={classes.message}>
            {state?.message}
          </span>
        }
        action={state?.action ? state?.action : [
          <IconButton key="close" aria-label="close" color="inherit" onClick={handleSnackBarClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  )
}

type snackbarOpenType = {
  duration?: number;
  handleClose?: (value: any) => void;
  variant?: 'error' | 'warning' | 'success' | 'important',
  className?: object;
  message: string | React.ReactNode;
  action?: React.ReactNode;
}

export const SNACKBAR_OPEN = (object: snackbarOpenType) => {
  const {
    duration,
    handleClose,
    variant,
    className,
    message,
    action
  } = object
  return ({
    type: SNACKBAR.set,
    payload: {
      open: true,
      duration: duration ? duration : null,
      handleClose: handleClose ? handleClose : null,
      variant: variant ? variant : null,
      className: className ? className : null,
      message: message ? message : null,
      action: action ? action : null,
    }
  })
}

export default SnackBarComponent

// eslint-disable-next-line
{ /*
dispatch(SNACKBAR_OPEN({
  message: `Already have permission`,
  duration: 1000,
  handleClose: ()=>{console.log('some function callback')},
  variant: 'error', // warning, success
  className: classes.someSnackBarClass,
  action: <><Button>UNDO</Button></>
}));
*/}